import { DEFAULT_SETTING_STATE } from '../../../common/constants'
import { createGenericSlice } from '../../../../../utils/slices'

export const settingSlice = createGenericSlice({
  name: 'settings',
  initialState: DEFAULT_SETTING_STATE,
  reducers: {
    setInputError: (state, action) => {
      state.error = action.payload
    },
    removeInputError: (state, action) => {
      const updatedError = { ...state.error }
      delete updatedError(action.payload)

      return updatedError
    },
  },
})

export const settingsActions = settingSlice.actions
